<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color" v-bind:class="{ 'bg-white': !showLoginImage }">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2" v-if="showLoginImage">
              <img v-if="setLoginImage" :src="img_cdn + setLoginImage" alt="login" class="mx-auto">
<!--              <img v-else :src="img_cdn + $t('images.pages.login')" alt="login" class="mx-auto">-->
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div  v-on:keyup.enter="submitData">
                  <vs-input
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email or Username"
                    v-model="email"
                    :tabindex="1"
                    data-vv-as="This field is required. Enter an email or username"
                    class="w-full"/>
<!--                  <span class="text-danger text-sm">{{ errors.first('username') }}</span>-->

                  <span v-if="email==''" v-show="errors.has($t('email'))" class="text-danger text-sm">This field is required. Enter an email or username</span>
                  <br>

                  <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                   v-model="password" 
                   icon="icon icon-lock"
                   icon-pack="feather"
                   icon-no-border
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border"
                  />
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors.first('password') }}</span> 
                  <div class="flex flex-wrap justify-between my-5 onfocus-check">
                    <input type="checkbox" v-model="checkbox_remember_me" id="checkbox_focus" class="checkbox_focus" :tabindex="3" /> <label for="checkbox_focus" class="ml-10">Remember Me</label>
                    <!-- <vs-checkbox v-model="checkbox_remember_me" :tabindex="3" class="mb-3" id="test5"></vs-checkbox> -->
                    <router-link to="forgot-password" class="onfocus-forgot" :tabindex="4">Forgot Password?</router-link>
                  </div>
                  <router-link to="/register" >
                    <vs-button type="border" class="onfocus-register" :tabindex="5">Register</vs-button>
                  </router-link>

                    <div id="div-with-loading" class="vs-con-loading__container float-right" :tabindex="6">

                  <vs-button class="float-right"   @click.native="submitData" :disabled="!validateForm">Login</vs-button>

                    </div>
<!--                  <vs-button  ref="loadableButton"-->
<!--                             id="button-with-loading"-->
<!--                             class="vs-con-loading__container float-right"-->
<!--                              @click="submitData"-->
<!--                              type="relief"-->
<!--                              :disabled="!validateForm">Login</vs-button>-->

                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {ADD_LOGIN_TIME, APP_TOKEN, CREATE_LOGIN_COUNTER, GET_IMAGE_SETTING, LOGIN_MUTATION, ROLES_KEY} from '@/graphql'


export default {
  props: {
    tabindex: {
      type: Number,
      required: false,
      default: 1
    }},
  data () {
    return {
      email: '',
      password: '',
      loader:true,
      checkbox_remember_me: false,
      roles: [],
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setLoginImage:'',
      showLoginImage:false,
      showPassword:false
    }
  },

  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }


  },
  methods: {
    openLoadingInDiv () {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-with-loading',
        scale: 0.45
      })

    },
    LoginCounter (id) {
      this.$apollo
        .mutate({
          mutation: CREATE_LOGIN_COUNTER,
          variables: {
            user_id: id
          }
        }).then(response => {
          if (response) {
            // window.location = '/'
          }

        })
        .catch(error => {

        })
    },
    LastLogin (id) {
      this.$apollo
        .mutate({
          mutation: ADD_LOGIN_TIME,
          variables: {
            id
          }
        })
        .then(response => {
          if (response) {
          // window.location = '/'
          }

        })
        .catch(error => {

        })
    },
    setCheckBoxvalue () {
      this.checkbox_remember_me = !this.checkbox_remember_me
    },
    submitData () {
      if (this.email != '' &&  this.password != '') {
        this.openLoadingInDiv()
        this.$apollo
          .mutate({
            mutation: LOGIN_MUTATION,
            variables: {
              email: this.email,
              password: this.password
            }
          })
          .then(response => {
          // redirect user;
            localStorage.setItem('userEmailPhone',  JSON.stringify({'email':response.data.login.user.email,'phone':response.data.login.user.phone,'email_confirmed':response.data.login.user.email_confirmed,'phone_verified':response.data.login.user.phone_verified}))
            if (response.data.login.user.pending == true) {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.AccountPendingNotification()
            } else if (response.data.login.user.status == false) {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.AccountApprovalNotification()
            } else if (response.data.login.user.roles == '') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.NotAuthorizedNotification()
            } else if (response.data.login.status == 'SUCCESS') {
              localStorage.removeItem(ROLES_KEY)
              // save user token to localstorage
              // console.log(response.data.login)
              localStorage.setItem(APP_TOKEN, response.data.login.access_token)
              localStorage.setItem(ROLES_KEY, JSON.stringify(response.data.login.user.roles))
              localStorage.setItem('userId', response.data.login.user.id)
              this.StatusSuccess()
              if (response.data.login.user.avatar !== null) {
                localStorage.setItem('userImage', response.data.login.user.avatar)
              } else {
                localStorage.removeItem('userImage')
              }
              localStorage.setItem('userName', `${response.data.login.user.fname  } ${  response.data.login.user.lname}`)
              this.LastLogin(response.data.login.user.id)
              this.$acl.change(response.data.login.user.roles[0].name)
              if(response.data.login.user.roles[0].name!=='user'){
                window.location = '/'
              }
              else{
               if(process.env.VUE_APP_I18N_LOCALE==='dogs'){
                 window.location = '/contact/pets/cameras'
               }
               else{
                  window.location = '/user/students/cameras'
               }
              }
              // this.LoginCounter(response.data.login.user.id)
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')

            } else if (response.data.login.status == 'PENDING') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.AccountPendingNotification()

            } else if (response.data.login.status == 'LOGIN_LIMITES_OVER') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              var message = 'Your logins limit for today has expired!'
              this.LoginLimiteNotification(message)


            } else if (response.data.login.status == 'NO_STUDENT_ASSOCIATED') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              var message = 'You don\'t have any student associated with your account!'
              this.LoginLimiteNotification(message)

            } else if (response.data.login.status == 'NO_CAMERA_ASSOCIATED') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              var message = 'You don’t have access to any camera.  Please contact customer support.'
              this.LoginLimiteNotification(message)

            } else if (response.data.login.status == 'NO_LOCATION_ASSOCIATED') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              var message = 'You don’t have access to any camera.  Please contact customer support.'
              this.LoginLimiteNotification(message)

            }
          })
          .catch(error => {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')

            this.StatusInvalid()
          })
      }
    },

    StatusSuccess () {

      this.$vs.notify({
        title: 'User',
        text: 'Logged in successfully',
        color: 'success',
        position: 'top-right'
      })

    },
    LoginLimiteNotification (message) {
      this.$vs.notify({
        title: 'Warning',
        text: message,
        color: 'danger',
        position: 'top-right'
      })
    },
    NotAuthorizedNotification () {
      this.$vs.notify({
        title: 'Authorization Failed',
        text: 'User Not Authorized!',
        color: 'danger',
        position: 'top-right'
      })
    },
    AccountApprovalNotification () {
      this.$vs.notify({
        title: 'Account Approval',
        text: 'Your account is disabled.!',
        color: 'danger',
        position: 'top-right'
      })
    },
    AccountPendingNotification () {
      this.$vs.notify({
        title: 'Warning',
        text: 'Your account is pending. Please contact customer support.!',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusInvalid () {
      this.$vs.notify({
        title: 'Invalid Data',
        text: 'Username Or Password Invalid!',
        color: 'danger',
        position: 'top-right'
      })
    }
  },
  beforeCreate () {
     if(localStorage.getItem('app-token')){
        localStorage.getItem('userRoles')
        const userRoles = JSON.parse(localStorage.getItem('userRoles'))
          if(userRoles[0].name!='user'){
            window.location = '/'
          }
          else{
          if(process.env.VUE_APP_I18N_LOCALE==='dogs'){
          window.location = '/contact/pets/cameras'
          }
          else{
          window.location = '/user/students/cameras'
          }
          }
     }
    else{
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING
      })
      .then(response => {
        console.log(response)
        if (response.data.getImagesSetting.login_page_image != null) {
          this.setLoginImage = response.data.getImagesSetting.login_page_image
        }
         if (response.data.getImagesSetting.show_login_img != null) {
          this.showLoginImage = response.data.getImagesSetting.show_login_img
        }
      })
      .catch(error => {
        console.log(error)
      })
           }

  },
 



}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
.onfocus:focus {

  opacity: 0.7;
  text-shadow: 2px 2px 2px red;
}
#div-with-loading:focus {
   box-shadow:0 8px 25px -8px rgba(var(--vs-primary),1)
}
.onfocus-register:focus {
  background: rgba(var(--vs-primary),.08)!important;
}.onfocus-forgot:focus {
   color: blue;
   text-shadow: 0 0 black
}
.onfocus-check .vs-checkbox-primary .vs-checkbox:focus {

  border:3px solid #b4b4b4 !important;
  background: red !important;

}
</style>
<style>
 #checkbox_focus {
    visibility: visible;
     height: 20px;
     width: 30px;
     position: absolute;
  }
  input[type="checkbox"].checkbox_focus:focus + label{
  border: 1px solid black;
  
}
.no-right-border .vs-inputx{
  border-right: none !important;
}

</style>